<div [attr.dir]="currentLang === 'ar' ? 'rtl' : 'ltr'">
  <div class="bg-white pt-5 px-4 pb-4 ms-2 border-b top-0 z-40">
    <div class="flex items-center justify-between mb-2">
      <div class="flex items-center gap-2 text-sm text-gray-600">
        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <circle cx="10" cy="10" r="3"></circle>
        </svg>
        <span>
          {{
            currentSelectedCompanyId == 0
              ? ("DASHBOARD.HOME.OVERVIEW_ALL_COMPANIES" | translate)
              : "Overview of " + getCompanyName(currentSelectedCompanyId)
          }}
        </span>
      </div>

      <div class="flex items-center gap-4">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5 text-teal-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
            ></path>
          </svg>
          <span class="text-gray-700 font-medium"
            >{{ "COMMON.COMPANY" | translate }}:</span
          >
          <select
            class="border border-gray-300 rounded px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
            [(ngModel)]="currentSelectedCompanyId"
            (change)="onCompanyChange()"
          >
            <option value="0">
              {{ "DASHBOARD.HOME.ALL_COMPANIES" | translate }}
            </option>

            <option *ngFor="let company of companies" [value]="company.id">
              {{ company.name }}
            </option>
          </select>
        </div>

        <button
          (click)="refreshDashboard()"
          [disabled]="isLoading"
          class="bg-teal-500 hover:bg-teal-600 disabled:bg-gray-400 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
        >
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            ></path>
          </svg>
          {{ "DASHBOARD.HOME.REFRESH" | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="min-h-screen bg-gray-50 pt-10">
    <div class="mx-10">
      <!-- User Profile Card -->
      <div class="flex">
        <div class="bg-white rounded-xl p-8 mb-6 shadow-lg basis-[70%] border">
          <div class="flex items-start justify-between">
            <div class="flex items-start gap-4">
              <div
                class="w-10 h-10 shadow-lg rounded-xl bg-[#00BBA7] flex items-center justify-center text-white font-medium"
                [title]="userFullName"
              >
                {{ userInitials }}
              </div>
              <div>
                <h2 class="text-xl font-semibold text-gray-900 mb-1">
                  {{ "DASHBOARD.HOME.HELLO" | translate }}
                  {{ userData?.firstName }} {{ userData?.lastName }}
                </h2>
                <div class="flex items-center gap-2 text-sm text-teal-500">
                  <span class="w-2 h-2 bg-teal-500 rounded-full"></span>
                  <span>{{ "COMMON.ACTIVE_NOW" | translate }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="mt-6 grid grid-cols-3 gap-4 pt-4 border-t border-gray-200"
          >
            <div class="text-sm p-4 bg-[#F9FAFB] rounded-xl">
              <span class="text-gray-500 uppercase tracking-wide">{{
                "DASHBOARD.HOME.LAST_LOGIN" | translate
              }}</span>
              <div class="text-gray-900 font-medium mt-1">
                12/24/2025 10:30 AM
              </div>
            </div>
            <div class="text-sm p-4 bg-[#F9FAFB] rounded-xl">
              <span class="text-gray-500 uppercase tracking-wide">{{
                "DASHBOARD.HOME.YOUR_MOBILE_NUMBER" | translate
              }}</span>
              <div class="text-gray-900 font-medium mt-1">
                {{ userData?.attributes?.PhoneNumber || "N/A" }}
              </div>
            </div>
            <div class="text-sm p-4 bg-[#F9FAFB] rounded-xl">
              <span class="text-gray-500 uppercase tracking-wide">{{
                "DASHBOARD.HOME.YOUR_EMAIL_ADDRESS" | translate
              }}</span>
              <div class="text-gray-900 font-medium mt-1">
                {{ userData?.email || "N/A" }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="bg-white border shadow-md border-gray-200 rounded-xl ms-6 p-4 basis-[30%] mb-6"
        >
          <div class="flex items-center justify-between mb-3">
            <div class="flex items-center gap-2">
              <div
                class="w-10 h-10 bg-[#E6FFFA] rounded-lg flex items-center justify-center"
              >
                <img
                  src="assets/icons/total-companies.svg"
                  alt="Companies Icon"
                  class="w-10 h-10 p-2"
                />
              </div>
              <span class="font-semibold text-gray-900">{{
                "DASHBOARD.HOME.TOTAL_COMPANIES" | translate
              }}</span>
            </div>
            <span class="text-3xl me-4 font-bold text-gray-900">{{
              companyCount
            }}</span>
          </div>
        </div>
      </div>

      <!-- Stats Grid -->
      <div class="grid grid-cols-4 gap-4">
        <!-- Active Policies -->
        <div class="bg-white rounded-xl shadow-md p-6 relative overflow-hidden">
          <div class="flex items-start justify-between mb-4">
            <div
              class="w-12 h-12 bg-[#F0FDFA] rounded-lg flex items-center justify-center"
            >
              <img
                src="assets/icons/shield.svg"
                alt="Policy Icon"
                class="w-6 h-6"
              />
            </div>
          </div>
          <h3 class="text-gray-600 text-sm font-medium mb-2">
            {{ "DASHBOARD.HOME.ACTIVE_POLICIES" | translate }}
          </h3>
          <p class="text-3xl font-bold text-gray-900">
            {{ totalActivePolicies }}
          </p>
        </div>

        <!-- Total Employees -->
        <div class="bg-white rounded-xl shadow-md p-6 relative overflow-hidden">
          <div class="flex items-start justify-between mb-4">
            <div
              class="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center"
            >
              <img
                src="assets/icons/employees.svg"
                alt="Policy Icon"
                class="w-6 h-6"
              />
            </div>
          </div>
          <h3 class="text-gray-600 text-sm font-medium mb-1">
            {{ "DASHBOARD.HOME.TOTAL_EMPLOYEES" | translate }}
          </h3>
          <p class="text-3xl font-bold text-gray-900">{{ totalEmployees }}</p>
        </div>

        <!-- Active Quotes -->
        <div class="bg-white rounded-xl shadow-md p-6 relative overflow-hidden">
          <div class="flex items-start justify-between mb-4">
            <div
              class="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center"
            >
              <img
                src="assets/icons/active-quotes.svg"
                alt="Policy Icon"
                class="w-6 h-6"
              />
            </div>
          </div>
          <h3 class="text-gray-600 text-sm font-medium mb-1">
            {{ "DASHBOARD.HOME.ACTIVE_QUOTES" | translate }}
          </h3>
          <p class="text-3xl font-bold text-gray-900">{{ activeQuotes }}</p>
        </div>

        <!-- Expired Policies -->
        <div class="bg-white rounded-xl shadow-md p-6 relative overflow-hidden">
          <div class="flex items-start justify-between mb-4">
            <div
              class="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center"
            >
              <img
                src="assets/icons/expired-policies.svg"
                alt="Policy Icon"
                class="w-6 h-6"
              />
            </div>
          </div>
          <h3 class="text-gray-600 text-sm font-medium mb-1">
            {{ "DASHBOARD.HOME.EXPIRED_POLICIES" | translate }}
          </h3>
          <p class="text-3xl font-bold text-gray-900">{{ expiredPolicies }}</p>
        </div>
      </div>

      <!-- Info Note -->
      <div
        class="mt-6 flex items-center bg-white border rounded-full max-w-[540px] mx-auto p-2 justify-center gap-2 text-sm text-gray-600"
      >
        <svg
          class="w-5 h-5 text-teal-500"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <circle cx="10" cy="10" r="3"></circle>
        </svg>
        <span>{{ "DASHBOARD.HOME.AUTO_UPDATE_NOTE" | translate }}</span>
      </div>
    </div>
  </div>
</div>
